<template>
  <div class="header-container header-menu" :class="[{ 'side-nav': isSideNav },{'header-collapse':collapse},{'mode-demo' : componentStyle.mode=='demo','have-switch': componentStyle.switchMode} ]">
    <div class="desktop-header d-none d-lg-block">
      <div class="container">
        <nav class="navbar navbar-expand-lg navbar-light" :class="{'isFM': isFM}">
          <router-link class="navbar-brand" :class="{'isFM': isFM}" :to="{ name: 'index' }" v-show="showLogo">
            <span class="logo-container">
              <img :src="getLogo" class="image_base64 logo" alt="Logo" v-if="componentStyle.mode=='default'" />
              <!-- demo logo mode dark/light -->
             <div id="light-logo" v-if="componentStyle.mode=='demo' && !isFM">
                   <img src="../assets/img/logo/logoDemoBlack.png" class="image_base64 logo" alt="Logo"  />
              </div>
              <div id="dark-logo" v-if="componentStyle.mode=='demo' && !isFM">
                   <img src="../assets/img/logo/logoDemoWhite.png" class="image_base64 logo" alt="Logo"  />
              </div>

              <!-- fgm logo mode dark/light -->
               <div id="light-fg-logo" class="isFM" v-if="componentStyle.mode=='demo' && isFM">
                   <img src="../assets/img/logo/logoFrogBlack.png" class="image_base64 logo" alt="Logo"  />
              </div>
              <div id="dark-fg-logo" class="isFM" v-if="componentStyle.mode=='demo' && isFM">
                   <img src="../assets/img/logo/logoFrogWhite.png" class="image_base64 logo" alt="Logo"  />
              </div>
            </span>
          </router-link>
          <!--<b class="c-black">Ensemble, allons plus loin</b>-->
         <span class="empty-container":class="{'isFM': isFM}"></span>
          <div
            class="search-input-container form-group"
            :class="[
              { 'full-width': isFullWidth, 'side-nav': isSideNav },
              componentStyle.searchInput,
              {'isFM':isFM}
            ]"
          >
            <search-bar
              :in-submit="search"
              :placeholder="$t('buttons.search')"
              :input="title"
            ></search-bar>

            <div class="switch-mode" v-if="componentStyle.switchMode">
              <switch-mode :id="'switchMode-desktop'"></switch-mode>
            </div>
            <button
              type="button"
              class="btn btn-lg btnLive"
              @click="redirectLive"
              v-show="isSideNav"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="#ffffff"
                width="32px"
                height="32px"
                viewBox="0 0 437.274 318.75"
                style="margin-right: 0.5em;"
              >
                <g id="noun_live_2146916" transform="translate(-2.5 -15.35)">
                  <g id="btnLiveGroupe" data-name="Groupe 2" transform="translate(2.5 15.35)">
                    <path
                      class="big-arc"
                      d="M105.4,20.183c-6.444-6.444-16.57-6.444-22.554,0-6.444,6.444-6.444,16.57,0,22.554a186.286,186.286,0,0,1,54.314,132.1A183.759,183.759,0,0,1,82.383,306.483c-6.444,6.444-6.444,16.57,0,22.554a16.685,16.685,0,0,0,23.014,0,216.869,216.869,0,0,0,63.98-154.657C169.378,116.383,146.823,61.149,105.4,20.183Z"
                      transform="translate(267.897 -15.35)"
                      fill="#ffffff"
                    />
                    <path
                      class="big-arc"
                      d="M34.72,174.48c0-50.171,19.332-96.661,54.774-131.643,6.444-6.444,6.444-16.57,0-22.554-6.444-6.444-16.57-6.444-22.554,0C25.054,60.788,2.5,116.023,2.5,174.48A216.869,216.869,0,0,0,66.48,329.137a16.685,16.685,0,0,0,23.014,0c6.444-6.444,6.444-16.57,0-22.554A185.6,185.6,0,0,1,34.72,174.48Z"
                      transform="translate(-2.5 -14.99)"
                      fill="#ffffff"
                    />
                    <path
                      class="small-arc"
                      d="M93.237,31.983c-6.444-6.444-16.57-6.444-22.554,0-6.444,6.444-6.444,16.57,0,22.554a109.053,109.053,0,0,1,32.22,77.329,109.052,109.052,0,0,1-32.22,77.328c-6.444,6.444-6.444,16.57,0,22.554a16.685,16.685,0,0,0,23.014,0,140.318,140.318,0,0,0,41.426-99.883A143.53,143.53,0,0,0,93.237,31.983Z"
                      transform="translate(225.743 27.164)"
                      fill="#ffffff"
                    />
                    <path
                      class="small-arc"
                      d="M51.06,131.966A108.261,108.261,0,0,1,83.28,54.637c6.444-6.444,6.444-16.57,0-22.554-6.444-6.444-16.57-6.444-22.554,0a141.684,141.684,0,0,0,.46,200.686A16.112,16.112,0,0,0,84.2,210.215,109.078,109.078,0,0,1,51.06,131.966Z"
                      transform="translate(58.029 27.524)"
                      fill="#ffffff"
                    />
                    <path
                      d="M63.654,38.836A14.481,14.481,0,0,0,41.1,50.8V147a14.481,14.481,0,0,0,22.554,11.967l72.265-48.33a14.621,14.621,0,0,0,0-24.4Z"
                      transform="translate(136.571 60.356)"
                    />
                  </g>
                </g>
              </svg>
              Live
            </button>
          </div>

          <b-dropdown
            class="dropdown-lang"
            v-has-permission="'videos_multiple_languages'"
            v-if="showLang"
            v-model="selectedLang"
          >
            <div slot="button-content" class="dropdown-image">
              <img class="image_Lang" :src="selectedLang.image" />
              <span class="dropdown-text lang-current">{{ selectedLang.text }}</span>
            </div>
            <b-dropdown-item
              v-for="option in langs"
              :key="option.value"
              :value="option.value"
              @click="changeLang(option)"
            >
              <img :src="option.image" class="image_Lang" />
              <span class="dropdown-text">{{ option.text }}</span>
            </b-dropdown-item>
          </b-dropdown>
        </nav>
      </div>
      <div class="navbar-container" v-show="isFullWidth" :class="componentStyle.navBar">
        <div class="navbarList">

          <list-items v-if="!NOT_LIST_THEME"
            :items="items"
            :current-index="currentTheme"
            :clickItem="itemClicked"
          ></list-items>
          <list-items v-if="NOT_LIST_THEME"
                      :items="homeData"
                      :current-index="currentCategory"
                      :clickItem="itemCategoryClicked"
          ></list-items>
          <button v-if="URL_LIVE && componentStyle.mode=='default'" type="button" class="btn btn-lg btn-primary btnLive d-flex" @click="redirectLive">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="#ffffff"
              width="24px"
              height="24px"
              viewBox="0 0 437.274 318.75"
              style="margin-right: 0.5em;"
            >
              <g id="noun_live_2146916" transform="translate(-2.5 -15.35)">
                <g id="btnLiveGroupe" data-name="Groupe 2" transform="translate(2.5 15.35)">
                  <path
                    class="big-arc"
                    d="M105.4,20.183c-6.444-6.444-16.57-6.444-22.554,0-6.444,6.444-6.444,16.57,0,22.554a186.286,186.286,0,0,1,54.314,132.1A183.759,183.759,0,0,1,82.383,306.483c-6.444,6.444-6.444,16.57,0,22.554a16.685,16.685,0,0,0,23.014,0,216.869,216.869,0,0,0,63.98-154.657C169.378,116.383,146.823,61.149,105.4,20.183Z"
                    transform="translate(267.897 -15.35)"
                    fill="#ffffff"
                  />
                  <path
                    class="big-arc"
                    d="M34.72,174.48c0-50.171,19.332-96.661,54.774-131.643,6.444-6.444,6.444-16.57,0-22.554-6.444-6.444-16.57-6.444-22.554,0C25.054,60.788,2.5,116.023,2.5,174.48A216.869,216.869,0,0,0,66.48,329.137a16.685,16.685,0,0,0,23.014,0c6.444-6.444,6.444-16.57,0-22.554A185.6,185.6,0,0,1,34.72,174.48Z"
                    transform="translate(-2.5 -14.99)"
                    fill="#ffffff"
                  />
                  <path
                    class="small-arc"
                    d="M93.237,31.983c-6.444-6.444-16.57-6.444-22.554,0-6.444,6.444-6.444,16.57,0,22.554a109.053,109.053,0,0,1,32.22,77.329,109.052,109.052,0,0,1-32.22,77.328c-6.444,6.444-6.444,16.57,0,22.554a16.685,16.685,0,0,0,23.014,0,140.318,140.318,0,0,0,41.426-99.883A143.53,143.53,0,0,0,93.237,31.983Z"
                    transform="translate(225.743 27.164)"
                    fill="#ffffff"
                  />
                  <path
                    class="small-arc"
                    d="M51.06,131.966A108.261,108.261,0,0,1,83.28,54.637c6.444-6.444,6.444-16.57,0-22.554-6.444-6.444-16.57-6.444-22.554,0a141.684,141.684,0,0,0,.46,200.686A16.112,16.112,0,0,0,84.2,210.215,109.078,109.078,0,0,1,51.06,131.966Z"
                    transform="translate(58.029 27.524)"
                    fill="#ffffff"
                  />
                  <path
                    d="M63.654,38.836A14.481,14.481,0,0,0,41.1,50.8V147a14.481,14.481,0,0,0,22.554,11.967l72.265-48.33a14.621,14.621,0,0,0,0-24.4Z"
                    transform="translate(136.571 60.356)"
                  />
                </g>
              </g>
            </svg>
            Live
          </button>

          <button v-if="!URL_LIVE && componentStyle.mode=='demo'" type="button" class="btn btn-lg btn-secondary btndemoLive d-flex" @click="redirectLive">
            <i class="icon-demo-live demo-icons-live"></i>
            Live
          </button>
        </div>
      </div>
    </div>
    <div class="mobile-header d-lg-none">

      <nav class="navbar navbar-expand-lg navbar-light">

        <div class="menu-label" v-if="collapse && componentStyle.mode=='demo' ">
          Menu
        </div>

        <router-link class="navbar-brand" :to="{ name: 'index' }" v-show="showLogo && !isSearchInputVisible">
          <span class="logo-container">
            <img :src="getLogo" class="image_base64" alt="Logo" v-if="componentStyle.mode=='default'" />

            <div id="light-logo-mobile" v-if="componentStyle.mode=='demo' && !collapse && !isFM">
                <svg width="100px" height="50px" viewBox="0 0 184 69" version="1.1" xmlns="http://www.w3.org/2000/svg">
                   <g  stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                      <g  fill="#191919">
                        <path d="M25.0113521,40 L25.5983372,40 C29.5272938,40 33.456436,40 37.3853926,40 C37.9965182,40 37.9991179,39.9994281 37.9993036,39.3765757 C38.0002321,35.136337 38.0002321,30.8960983 37.9993036,26.6558597 C37.9991179,26.0124171 37.9965182,26.0107013 37.3915205,26.0107013 C33.4623783,26.0101293 29.5334218,26.0181366 25.6044652,26 C25.1463531,25.9981184 24.9977963,26.1048822 25,26.6019058 C25.0197084,30.8737923 25.0113521,35.1458695 25.0113521,39.4179466 L25.0113521,40 Z M27.0110715,19 L42.3192432,19 C42.3336067,18.7267706 42.3455762,18.4953166 42.3586507,18.2435971 C42.6464731,18.2313311 42.8982025,18.2206651 43.1552723,18.2096434 C43.1712931,17.9301921 43.1847359,17.6987382 43.1992835,17.4457743 C43.4780826,17.4272864 43.7303645,17.4103985 43.9951685,17.3926217 C44.0165296,17.1209922 44.0356809,16.8786944 44.0552005,16.6285748 C44.3426546,16.6120424 44.581862,16.5983542 44.8391159,16.5835995 C44.8665539,16.3100145 44.8910455,16.0670057 44.9162737,15.8136863 C45.1998606,15.7925319 45.4510376,15.7738662 45.7077391,15.7546673 C45.7230233,15.4718384 45.7355453,15.2405622 45.748804,14.993998 C46.0371788,14.9698215 46.2885399,14.9486671 46.5513182,14.9266239 C46.5654976,14.6594386 46.5778355,14.4281624 46.5914624,14.1741319 C46.8691566,14.1533331 47.1207019,14.1346674 47.3878998,14.1147574 C47.4048413,13.8427724 47.4199414,13.6002968 47.4350415,13.3555103 C47.7296773,13.3395111 47.9698055,13.3265341 48.2270594,13.3128459 C48.247868,13.039261 48.2660986,12.7962521 48.2850658,12.5455992 C48.5703101,12.5303112 48.811359,12.5175119 49.0748739,12.5034682 C49.0984448,12.2414382 49.1205425,11.9973627 49.1444816,11.7321328 C49.4234649,11.7161337 49.6757468,11.7019123 49.9374202,11.6869798 C49.9543618,11.4105505 49.9687253,11.1776744 49.9843778,10.9236439 C50.2556269,10.899823 50.508093,10.8774243 50.780447,10.8534256 C50.797941,10.5837515 50.8135935,10.3418092 50.8299826,10.0913341 C51.1181732,10.070713 51.3570124,10.0536473 51.6735617,10.030893 C51.4150188,9.28995595 51.8492383,9.16605165 52.4582137,9.24533619 C52.4806797,8.95113013 52.4990944,8.70883234 52.5178775,8.46031267 C52.8097511,8.44360248 53.0500634,8.42973657 53.3095271,8.41462629 C53.3342028,8.15046303 53.3566688,7.90709863 53.3809762,7.64684627 C53.6647474,7.63351367 53.9164768,7.62160321 54.1733624,7.60951499 C54.1897515,7.32917484 54.2033784,7.09700983 54.2184785,6.84173497 C54.4959886,6.82395817 54.748823,6.80760351 55,6.79142662 L55,6.0097807 L53.7774455,6.0097807 C45.0490439,6.0097807 36.3206423,6.01315829 27.5922407,6 C27.1311356,5.99929239 26.9979971,6.10790864 27,6.56370581 C27.019174,10.5471313 27.0110715,14.5307346 27.0110715,18.51416 L27.0110715,19 Z M45,39 L59,39 L59,38.3788343 C59,29.4127515 59.0006842,20.4466687 58.9974444,11.480399 C58.9972539,11.0927543 58.947704,10.7052963 58.9448454,10.3174648 C58.9425585,10.0204261 58.7519822,9.96344704 58.5373934,10.0189316 C58.396367,10.0555477 58.2134138,10.1820226 58.1751079,10.3056953 C58.0800104,10.611888 58.0842031,10.9474108 57.9921547,11.2549112 C57.9570887,11.3714848 57.7710863,11.5149601 57.64664,11.5220591 C57.2845451,11.5427958 57.1139794,11.6907547 57.1450433,12.0440251 C57.171724,12.3464814 57.0373677,12.4850995 56.7303494,12.4496043 C56.3695885,12.408131 56.23447,12.5736506 56.2741098,12.9091735 C56.3116534,13.225641 56.1492824,13.3321266 55.8519834,13.2975655 C55.5268604,13.2598285 55.3686821,13.3891057 55.4121334,13.7192109 C55.4553943,14.048382 55.3042673,14.1823296 54.9759044,14.1404826 C54.6334389,14.0967675 54.5135664,14.2617267 54.5516817,14.5748316 C54.5878912,14.8711229 54.4691622,15.0220708 54.1510904,14.984147 C53.8019547,14.9423001 53.6433953,15.086149 53.6898959,15.4340018 C53.7344907,15.7680301 53.5690705,15.8857247 53.2475684,15.8513504 C52.8925248,15.8132398 52.7513078,15.9882871 52.7797037,16.3200736 C52.802954,16.5911447 52.6933727,16.7392904 52.4008381,16.7129492 C51.9968165,16.6768936 51.8603639,16.8709962 51.9009566,17.2423879 C51.91201,17.3432689 51.8765628,17.4490072 51.8626508,17.5511959 C51.588221,17.591922 51.2489953,17.5463387 51.1232149,17.6858908 C50.9791393,17.8454323 51.0244964,18.1693725 50.9873341,18.4238169 C50.7081399,18.4417514 50.4617248,18.4578176 50.2059714,18.4742575 C50.185008,18.7617684 50.167475,19.0038829 50.1457493,19.3027897 C49.3880182,19.1058849 49.2058273,19.5026836 49.2942547,20.0995631 C49.1922964,20.1223548 49.1446523,20.1457069 49.1004386,20.1408496 C48.6293341,20.0881673 48.3312729,20.2028728 48.3853965,20.7579054 C48.3922573,20.8285221 48.1555616,20.9946022 48.0358797,20.9910527 C47.6362413,20.9785359 47.4837803,21.135462 47.5278034,21.5163813 C47.5394285,21.6178228 47.5060777,21.7244952 47.4915939,21.842937 C47.211828,21.873575 46.9526443,21.9017843 46.6886962,21.9307409 C46.669448,22.2182518 46.6530584,22.4609268 46.6355254,22.7234043 C46.343372,22.7389101 46.0841883,22.7525477 45.8229082,22.7661854 C45.807281,23.066213 45.7945124,23.3101957 45.7807909,23.5747282 C45.5097915,23.5992012 45.2650916,23.6212456 45,23.6451581 L45,39 Z M12.5102026,55.5218013 C12.4914313,55.8193776 12.4750524,56.0800185 12.4573853,56.3589368 C12.1708468,56.3842583 11.9207467,56.4063433 11.6704625,56.4286187 C11.6522433,56.7296219 11.6375207,56.9754127 11.6216939,57.2349113 C11.338652,57.2575675 11.100146,57.2767966 10.8064302,57.3004047 C10.9661704,58.0156919 10.6544194,58.2765233 10,58.1348747 L10,58.9899066 L11.1279349,58.9899066 C19.8980012,58.9899066 28.6676995,58.9860989 37.4377659,59 C37.8949025,59.0007587 38.0014573,58.8474965 38,58.403512 C37.9867347,54.1367296 37.9872868,49.8699473 37.9992489,45.6033553 C38.0005371,45.1645112 37.8993193,44.9981123 37.4359256,45 C32.8824107,45.0175318 28.3288958,45.0106779 23.7751969,45.0106779 L22.6855407,45.0106779 C22.6603283,45.3448086 22.641557,45.5921224 22.6185529,45.8965526 C21.927143,45.7371979 21.6472297,46.0321087 21.7979522,46.7357823 C21.490434,46.7639597 21.2386776,46.787187 20.9666777,46.8121278 C20.9493786,47.1022789 20.9339199,47.3615872 20.9180931,47.6258455 C20.6273218,47.6445035 20.3878956,47.6597346 20.1271216,47.6762983 C20.1138713,47.9658782 20.1019092,48.2263288 20.089395,48.5014393 C19.7934708,48.5149568 19.5415304,48.5267609 19.2886698,48.5383745 C19.2733951,48.8426144 19.2608809,49.0906897 19.2474465,49.3551385 C18.9596198,49.3764619 18.7078634,49.3953103 18.4516902,49.4143491 C18.4296063,49.7054521 18.410651,49.9542891 18.3904074,50.2219744 C18.1138066,50.2455825 17.8618662,50.2672867 17.5950192,50.2901333 C17.5703588,50.5842825 17.548459,50.8426388 17.526191,51.1099434 C17.2403886,51.1301245 17.0013305,51.147069 16.7447893,51.1653463 C16.7227054,51.4633033 16.703566,51.7231827 16.6833224,51.995247 C16.4023049,52.0158088 16.1636148,52.0331341 15.9000803,52.0521729 C15.8844376,52.336422 15.870083,52.5968726 15.8549924,52.8691272 C15.5702942,52.8866429 15.3306839,52.9013028 15.0642049,52.9176762 C15.0470899,53.2009733 15.0314472,53.4612335 15.0148842,53.7348209 C14.7318423,53.7513846 14.491864,53.7650925 14.2286976,53.7803236 C14.2033011,54.0632399 14.179929,54.3242617 14.1554527,54.5959452 C13.8759074,54.6170782 13.623967,54.6359266 13.3549115,54.6562981 C13.3354041,54.9546359 13.3186572,55.2141345 13.3015421,55.4751563 C13.0063541,55.4924816 12.7660077,55.5067607 12.5102026,55.5218013 L12.5102026,55.5218013 Z M19.2326644,41.471833 C20,41.3262068 20,41.3262068 20,40.5587324 C20,35.9596659 20,31.360786 20,26.7617196 C20,26.0686431 20,26.0678973 19.3154144,26.0324697 C19.0629889,26.0194174 18.8105634,26.0015171 18.5579481,26.0015171 C14.6041673,25.999466 10.6505764,26 6.69679565,26 C6.00063265,26 6.00025306,26.0003983 6.00025306,26.6714723 C6,35.6365286 5.99873471,44.6013984 6.00480811,53.5664547 C6.0049979,53.9658547 6.05358507,54.3684245 6.12210056,54.7622307 C6.13937178,54.8608686 6.3173982,54.9908321 6.42994582,54.9994093 C6.54970559,55.0083595 6.7637928,54.9140101 6.78979453,54.8239493 C6.88677907,54.4894379 6.95282725,54.139823 6.97256578,53.7926322 C6.98907783,53.5058548 7.10105607,53.3911812 7.37739558,53.423066 C7.73022192,53.4637146 7.87826095,53.3152914 7.83309007,52.9716434 C7.79247423,52.6639823 7.93823573,52.5362564 8.24247491,52.5757862 C8.59492166,52.6216556 8.74163213,52.4555187 8.72739761,52.126974 C8.71449165,51.8249068 8.85930418,51.7031476 9.15955769,51.7286928 C9.48581293,51.756662 9.63157443,51.5877281 9.61221548,51.282864 C9.59285653,50.9787457 9.72685083,50.859597 10.0303308,50.8773108 C10.3408332,50.8953975 10.5091801,50.7527547 10.4820396,50.431109 C10.4600236,50.1721144 10.542394,50.0001971 10.8439761,50.0203349 C11.245959,50.0471853 11.3776758,49.8484177 11.334213,49.4807161 C11.3220662,49.3790947 11.3524332,49.2726254 11.3659085,49.1452723 C11.6481317,49.1258804 11.9060612,49.1081666 12.1647499,49.0904527 C12.1844884,48.79342 12.2004311,48.5519527 12.2158044,48.3188761 C12.3086135,48.3006029 12.3553027,48.2800922 12.3997144,48.2840079 C12.827699,48.322046 13.1530053,48.2702098 13.0748103,47.7080291 C13.0645615,47.6341905 13.3137605,47.4451188 13.4384549,47.4490345 C13.8313277,47.4613409 13.9998644,47.3162741 13.9628547,46.9344014 C13.9376121,46.6739151 14.0619269,46.5577497 14.3246013,46.5864648 C14.7235475,46.6300967 14.875762,46.4453136 14.8328686,46.0688484 C14.8066771,45.8389417 14.9044208,45.7026385 15.1522913,45.7294889 C15.6062776,45.7787147 15.7453964,45.5626061 15.6899766,45.154256 C15.6782094,45.067738 15.7061091,44.9761855 15.7182559,44.8648682 C15.9974423,44.8434251 16.256131,44.8232873 16.5262073,44.8024037 C16.5415806,44.5189826 16.5546764,44.2763965 16.5692905,44.0077059 C16.8543605,43.9918567 17.114188,43.9774991 17.387301,43.9622093 C17.4098864,43.6700246 17.4292454,43.4164373 17.4527798,43.1112002 C18.2523803,43.3461414 18.3839073,42.8855821 18.3508832,42.3282495 C19.1182188,42.2581401 19.1182188,42.2581401 19.2326644,41.471833 L19.2326644,41.471833 Z M1.6640443,65 C1.65029498,64.8636839 1.62110122,64.754631 1.63240203,64.6494996 C1.66875297,64.3118838 1.50959989,64.2022707 1.19167043,64.2360696 C0.950021443,64.2616522 0.731162419,64.2265462 0.778060781,63.9029355 C0.852834475,63.3884822 0.586888742,63.3147221 0.116586692,63.4370332 C0.096621927,63.6243278 0.074773694,63.8323499 0.0527371142,64.0405587 C0.0350325116,64.0398118 0.0175162558,64.0388781 0,64.0379444 L0,20.7799895 C0.0109241165,20.7781222 0.021848233,20.7762549 0.0329606964,20.7743875 C0.0531138079,20.9375934 0.0734552662,21.1007992 0.0988820891,21.3039662 L0.785971348,21.3039662 C0.640944284,20.6328428 0.919320908,20.3480729 1.56779907,20.4870033 C1.60320827,20.4024126 1.63955921,20.3587168 1.63503889,20.319876 C1.57589798,19.8158799 1.78439793,19.6795638 2.29914983,19.6812444 C7.60412682,19.6980505 12.9089155,19.6862862 18.2138925,19.6825515 C18.7461606,19.6821781 19.2786171,19.6825515 19.8882958,19.6825515 L19.8882958,0.976060651 C20.2276968,0.914438303 20.5814122,0.949731102 20.7352916,0.792874216 C20.8771167,0.64796833 20.8047915,0.29653421 20.8298417,0 L63.9648458,0 C63.9661642,0.0173662982 63.9672943,0.0349193307 63.9686127,0.0522856289 C63.8646453,0.0629294891 63.7365694,0.0399611592 63.6619841,0.0920600538 C63.535415,0.180572154 63.3579923,0.317074993 63.3593107,0.431916642 C63.3604408,0.548812369 63.5508594,0.761876307 63.6589705,0.762249776 C64.0646696,0.763556917 64.2447292,0.917052584 64.2066831,1.3200254 C64.1799379,1.60535554 64.3645178,1.66137586 64.5946776,1.64979833 C64.8990461,1.63429937 65.0120542,1.77042874 64.9952913,2.07051091 C64.9770217,2.39617568 65,2.7237078 65,3.05049298 C65,16.1215267 65,29.1925605 65,42.2635943 C65,42.7126905 65,43.1617867 65,43.6506573 C64.7227535,43.672692 64.4961722,43.6906185 64.2466127,43.7102256 C64.2274013,43.809755 64.1887902,43.899761 64.1970774,43.9850986 C64.2371953,44.3906857 64.1093078,44.6136465 63.6514367,44.5415671 C63.3559205,44.4950702 63.261747,44.656222 63.2794516,44.9268001 C63.2873622,45.0474305 63.2636305,45.1704885 63.2487511,45.3631984 L45.0503031,45.3631984 L45.0503031,64.1953615 C44.3387287,64.0485883 43.960905,64.243539 44.1264619,65 L1.6640443,65 Z" ></path>
                          <text id="empreinte.com" font-family="CoreSansAR-65Bold, Core Sans AR" font-size="18" font-weight="bold" letter-spacing="-0.5">
                            <tspan x="56" y="64">empreinte.com</tspan>
                          </text>
                      </g>
                    </g>
                </svg>
              </div>
            <div id="dark-logo-mobile" v-if="componentStyle.mode=='demo' && !collapse && !isFM">
                <svg width="100px" height="50px" viewBox="0 0 184 69" version="1.1" xmlns="http://www.w3.org/2000/svg"  >
                  <g  stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                    <g  fill="#FFFFFF">
                      <path d="M25.0113521,40 L25.5983372,40 C29.5272938,40 33.456436,40 37.3853926,40 C37.9965182,40 37.9991179,39.9994281 37.9993036,39.3765757 C38.0002321,35.136337 38.0002321,30.8960983 37.9993036,26.6558597 C37.9991179,26.0124171 37.9965182,26.0107013 37.3915205,26.0107013 C33.4623783,26.0101293 29.5334218,26.0181366 25.6044652,26 C25.1463531,25.9981184 24.9977963,26.1048822 25,26.6019058 C25.0197084,30.8737923 25.0113521,35.1458695 25.0113521,39.4179466 L25.0113521,40 Z M27.0110715,19 L42.3192432,19 C42.3336067,18.7267706 42.3455762,18.4953166 42.3586507,18.2435971 C42.6464731,18.2313311 42.8982025,18.2206651 43.1552723,18.2096434 C43.1712931,17.9301921 43.1847359,17.6987382 43.1992835,17.4457743 C43.4780826,17.4272864 43.7303645,17.4103985 43.9951685,17.3926217 C44.0165296,17.1209922 44.0356809,16.8786944 44.0552005,16.6285748 C44.3426546,16.6120424 44.581862,16.5983542 44.8391159,16.5835995 C44.8665539,16.3100145 44.8910455,16.0670057 44.9162737,15.8136863 C45.1998606,15.7925319 45.4510376,15.7738662 45.7077391,15.7546673 C45.7230233,15.4718384 45.7355453,15.2405622 45.748804,14.993998 C46.0371788,14.9698215 46.2885399,14.9486671 46.5513182,14.9266239 C46.5654976,14.6594386 46.5778355,14.4281624 46.5914624,14.1741319 C46.8691566,14.1533331 47.1207019,14.1346674 47.3878998,14.1147574 C47.4048413,13.8427724 47.4199414,13.6002968 47.4350415,13.3555103 C47.7296773,13.3395111 47.9698055,13.3265341 48.2270594,13.3128459 C48.247868,13.039261 48.2660986,12.7962521 48.2850658,12.5455992 C48.5703101,12.5303112 48.811359,12.5175119 49.0748739,12.5034682 C49.0984448,12.2414382 49.1205425,11.9973627 49.1444816,11.7321328 C49.4234649,11.7161337 49.6757468,11.7019123 49.9374202,11.6869798 C49.9543618,11.4105505 49.9687253,11.1776744 49.9843778,10.9236439 C50.2556269,10.899823 50.508093,10.8774243 50.780447,10.8534256 C50.797941,10.5837515 50.8135935,10.3418092 50.8299826,10.0913341 C51.1181732,10.070713 51.3570124,10.0536473 51.6735617,10.030893 C51.4150188,9.28995595 51.8492383,9.16605165 52.4582137,9.24533619 C52.4806797,8.95113013 52.4990944,8.70883234 52.5178775,8.46031267 C52.8097511,8.44360248 53.0500634,8.42973657 53.3095271,8.41462629 C53.3342028,8.15046303 53.3566688,7.90709863 53.3809762,7.64684627 C53.6647474,7.63351367 53.9164768,7.62160321 54.1733624,7.60951499 C54.1897515,7.32917484 54.2033784,7.09700983 54.2184785,6.84173497 C54.4959886,6.82395817 54.748823,6.80760351 55,6.79142662 L55,6.0097807 L53.7774455,6.0097807 C45.0490439,6.0097807 36.3206423,6.01315829 27.5922407,6 C27.1311356,5.99929239 26.9979971,6.10790864 27,6.56370581 C27.019174,10.5471313 27.0110715,14.5307346 27.0110715,18.51416 L27.0110715,19 Z M45,39 L59,39 L59,38.3788343 C59,29.4127515 59.0006842,20.4466687 58.9974444,11.480399 C58.9972539,11.0927543 58.947704,10.7052963 58.9448454,10.3174648 C58.9425585,10.0204261 58.7519822,9.96344704 58.5373934,10.0189316 C58.396367,10.0555477 58.2134138,10.1820226 58.1751079,10.3056953 C58.0800104,10.611888 58.0842031,10.9474108 57.9921547,11.2549112 C57.9570887,11.3714848 57.7710863,11.5149601 57.64664,11.5220591 C57.2845451,11.5427958 57.1139794,11.6907547 57.1450433,12.0440251 C57.171724,12.3464814 57.0373677,12.4850995 56.7303494,12.4496043 C56.3695885,12.408131 56.23447,12.5736506 56.2741098,12.9091735 C56.3116534,13.225641 56.1492824,13.3321266 55.8519834,13.2975655 C55.5268604,13.2598285 55.3686821,13.3891057 55.4121334,13.7192109 C55.4553943,14.048382 55.3042673,14.1823296 54.9759044,14.1404826 C54.6334389,14.0967675 54.5135664,14.2617267 54.5516817,14.5748316 C54.5878912,14.8711229 54.4691622,15.0220708 54.1510904,14.984147 C53.8019547,14.9423001 53.6433953,15.086149 53.6898959,15.4340018 C53.7344907,15.7680301 53.5690705,15.8857247 53.2475684,15.8513504 C52.8925248,15.8132398 52.7513078,15.9882871 52.7797037,16.3200736 C52.802954,16.5911447 52.6933727,16.7392904 52.4008381,16.7129492 C51.9968165,16.6768936 51.8603639,16.8709962 51.9009566,17.2423879 C51.91201,17.3432689 51.8765628,17.4490072 51.8626508,17.5511959 C51.588221,17.591922 51.2489953,17.5463387 51.1232149,17.6858908 C50.9791393,17.8454323 51.0244964,18.1693725 50.9873341,18.4238169 C50.7081399,18.4417514 50.4617248,18.4578176 50.2059714,18.4742575 C50.185008,18.7617684 50.167475,19.0038829 50.1457493,19.3027897 C49.3880182,19.1058849 49.2058273,19.5026836 49.2942547,20.0995631 C49.1922964,20.1223548 49.1446523,20.1457069 49.1004386,20.1408496 C48.6293341,20.0881673 48.3312729,20.2028728 48.3853965,20.7579054 C48.3922573,20.8285221 48.1555616,20.9946022 48.0358797,20.9910527 C47.6362413,20.9785359 47.4837803,21.135462 47.5278034,21.5163813 C47.5394285,21.6178228 47.5060777,21.7244952 47.4915939,21.842937 C47.211828,21.873575 46.9526443,21.9017843 46.6886962,21.9307409 C46.669448,22.2182518 46.6530584,22.4609268 46.6355254,22.7234043 C46.343372,22.7389101 46.0841883,22.7525477 45.8229082,22.7661854 C45.807281,23.066213 45.7945124,23.3101957 45.7807909,23.5747282 C45.5097915,23.5992012 45.2650916,23.6212456 45,23.6451581 L45,39 Z M12.5102026,55.5218013 C12.4914313,55.8193776 12.4750524,56.0800185 12.4573853,56.3589368 C12.1708468,56.3842583 11.9207467,56.4063433 11.6704625,56.4286187 C11.6522433,56.7296219 11.6375207,56.9754127 11.6216939,57.2349113 C11.338652,57.2575675 11.100146,57.2767966 10.8064302,57.3004047 C10.9661704,58.0156919 10.6544194,58.2765233 10,58.1348747 L10,58.9899066 L11.1279349,58.9899066 C19.8980012,58.9899066 28.6676995,58.9860989 37.4377659,59 C37.8949025,59.0007587 38.0014573,58.8474965 38,58.403512 C37.9867347,54.1367296 37.9872868,49.8699473 37.9992489,45.6033553 C38.0005371,45.1645112 37.8993193,44.9981123 37.4359256,45 C32.8824107,45.0175318 28.3288958,45.0106779 23.7751969,45.0106779 L22.6855407,45.0106779 C22.6603283,45.3448086 22.641557,45.5921224 22.6185529,45.8965526 C21.927143,45.7371979 21.6472297,46.0321087 21.7979522,46.7357823 C21.490434,46.7639597 21.2386776,46.787187 20.9666777,46.8121278 C20.9493786,47.1022789 20.9339199,47.3615872 20.9180931,47.6258455 C20.6273218,47.6445035 20.3878956,47.6597346 20.1271216,47.6762983 C20.1138713,47.9658782 20.1019092,48.2263288 20.089395,48.5014393 C19.7934708,48.5149568 19.5415304,48.5267609 19.2886698,48.5383745 C19.2733951,48.8426144 19.2608809,49.0906897 19.2474465,49.3551385 C18.9596198,49.3764619 18.7078634,49.3953103 18.4516902,49.4143491 C18.4296063,49.7054521 18.410651,49.9542891 18.3904074,50.2219744 C18.1138066,50.2455825 17.8618662,50.2672867 17.5950192,50.2901333 C17.5703588,50.5842825 17.548459,50.8426388 17.526191,51.1099434 C17.2403886,51.1301245 17.0013305,51.147069 16.7447893,51.1653463 C16.7227054,51.4633033 16.703566,51.7231827 16.6833224,51.995247 C16.4023049,52.0158088 16.1636148,52.0331341 15.9000803,52.0521729 C15.8844376,52.336422 15.870083,52.5968726 15.8549924,52.8691272 C15.5702942,52.8866429 15.3306839,52.9013028 15.0642049,52.9176762 C15.0470899,53.2009733 15.0314472,53.4612335 15.0148842,53.7348209 C14.7318423,53.7513846 14.491864,53.7650925 14.2286976,53.7803236 C14.2033011,54.0632399 14.179929,54.3242617 14.1554527,54.5959452 C13.8759074,54.6170782 13.623967,54.6359266 13.3549115,54.6562981 C13.3354041,54.9546359 13.3186572,55.2141345 13.3015421,55.4751563 C13.0063541,55.4924816 12.7660077,55.5067607 12.5102026,55.5218013 L12.5102026,55.5218013 Z M19.2326644,41.471833 C20,41.3262068 20,41.3262068 20,40.5587324 C20,35.9596659 20,31.360786 20,26.7617196 C20,26.0686431 20,26.0678973 19.3154144,26.0324697 C19.0629889,26.0194174 18.8105634,26.0015171 18.5579481,26.0015171 C14.6041673,25.999466 10.6505764,26 6.69679565,26 C6.00063265,26 6.00025306,26.0003983 6.00025306,26.6714723 C6,35.6365286 5.99873471,44.6013984 6.00480811,53.5664547 C6.0049979,53.9658547 6.05358507,54.3684245 6.12210056,54.7622307 C6.13937178,54.8608686 6.3173982,54.9908321 6.42994582,54.9994093 C6.54970559,55.0083595 6.7637928,54.9140101 6.78979453,54.8239493 C6.88677907,54.4894379 6.95282725,54.139823 6.97256578,53.7926322 C6.98907783,53.5058548 7.10105607,53.3911812 7.37739558,53.423066 C7.73022192,53.4637146 7.87826095,53.3152914 7.83309007,52.9716434 C7.79247423,52.6639823 7.93823573,52.5362564 8.24247491,52.5757862 C8.59492166,52.6216556 8.74163213,52.4555187 8.72739761,52.126974 C8.71449165,51.8249068 8.85930418,51.7031476 9.15955769,51.7286928 C9.48581293,51.756662 9.63157443,51.5877281 9.61221548,51.282864 C9.59285653,50.9787457 9.72685083,50.859597 10.0303308,50.8773108 C10.3408332,50.8953975 10.5091801,50.7527547 10.4820396,50.431109 C10.4600236,50.1721144 10.542394,50.0001971 10.8439761,50.0203349 C11.245959,50.0471853 11.3776758,49.8484177 11.334213,49.4807161 C11.3220662,49.3790947 11.3524332,49.2726254 11.3659085,49.1452723 C11.6481317,49.1258804 11.9060612,49.1081666 12.1647499,49.0904527 C12.1844884,48.79342 12.2004311,48.5519527 12.2158044,48.3188761 C12.3086135,48.3006029 12.3553027,48.2800922 12.3997144,48.2840079 C12.827699,48.322046 13.1530053,48.2702098 13.0748103,47.7080291 C13.0645615,47.6341905 13.3137605,47.4451188 13.4384549,47.4490345 C13.8313277,47.4613409 13.9998644,47.3162741 13.9628547,46.9344014 C13.9376121,46.6739151 14.0619269,46.5577497 14.3246013,46.5864648 C14.7235475,46.6300967 14.875762,46.4453136 14.8328686,46.0688484 C14.8066771,45.8389417 14.9044208,45.7026385 15.1522913,45.7294889 C15.6062776,45.7787147 15.7453964,45.5626061 15.6899766,45.154256 C15.6782094,45.067738 15.7061091,44.9761855 15.7182559,44.8648682 C15.9974423,44.8434251 16.256131,44.8232873 16.5262073,44.8024037 C16.5415806,44.5189826 16.5546764,44.2763965 16.5692905,44.0077059 C16.8543605,43.9918567 17.114188,43.9774991 17.387301,43.9622093 C17.4098864,43.6700246 17.4292454,43.4164373 17.4527798,43.1112002 C18.2523803,43.3461414 18.3839073,42.8855821 18.3508832,42.3282495 C19.1182188,42.2581401 19.1182188,42.2581401 19.2326644,41.471833 L19.2326644,41.471833 Z M1.6640443,65 C1.65029498,64.8636839 1.62110122,64.754631 1.63240203,64.6494996 C1.66875297,64.3118838 1.50959989,64.2022707 1.19167043,64.2360696 C0.950021443,64.2616522 0.731162419,64.2265462 0.778060781,63.9029355 C0.852834475,63.3884822 0.586888742,63.3147221 0.116586692,63.4370332 C0.096621927,63.6243278 0.074773694,63.8323499 0.0527371142,64.0405587 C0.0350325116,64.0398118 0.0175162558,64.0388781 0,64.0379444 L0,20.7799895 C0.0109241165,20.7781222 0.021848233,20.7762549 0.0329606964,20.7743875 C0.0531138079,20.9375934 0.0734552662,21.1007992 0.0988820891,21.3039662 L0.785971348,21.3039662 C0.640944284,20.6328428 0.919320908,20.3480729 1.56779907,20.4870033 C1.60320827,20.4024126 1.63955921,20.3587168 1.63503889,20.319876 C1.57589798,19.8158799 1.78439793,19.6795638 2.29914983,19.6812444 C7.60412682,19.6980505 12.9089155,19.6862862 18.2138925,19.6825515 C18.7461606,19.6821781 19.2786171,19.6825515 19.8882958,19.6825515 L19.8882958,0.976060651 C20.2276968,0.914438303 20.5814122,0.949731102 20.7352916,0.792874216 C20.8771167,0.64796833 20.8047915,0.29653421 20.8298417,0 L63.9648458,0 C63.9661642,0.0173662982 63.9672943,0.0349193307 63.9686127,0.0522856289 C63.8646453,0.0629294891 63.7365694,0.0399611592 63.6619841,0.0920600538 C63.535415,0.180572154 63.3579923,0.317074993 63.3593107,0.431916642 C63.3604408,0.548812369 63.5508594,0.761876307 63.6589705,0.762249776 C64.0646696,0.763556917 64.2447292,0.917052584 64.2066831,1.3200254 C64.1799379,1.60535554 64.3645178,1.66137586 64.5946776,1.64979833 C64.8990461,1.63429937 65.0120542,1.77042874 64.9952913,2.07051091 C64.9770217,2.39617568 65,2.7237078 65,3.05049298 C65,16.1215267 65,29.1925605 65,42.2635943 C65,42.7126905 65,43.1617867 65,43.6506573 C64.7227535,43.672692 64.4961722,43.6906185 64.2466127,43.7102256 C64.2274013,43.809755 64.1887902,43.899761 64.1970774,43.9850986 C64.2371953,44.3906857 64.1093078,44.6136465 63.6514367,44.5415671 C63.3559205,44.4950702 63.261747,44.656222 63.2794516,44.9268001 C63.2873622,45.0474305 63.2636305,45.1704885 63.2487511,45.3631984 L45.0503031,45.3631984 L45.0503031,64.1953615 C44.3387287,64.0485883 43.960905,64.243539 44.1264619,65 L1.6640443,65 Z"  fill-rule="nonzero"></path>
                      <text id="empreinte.com" font-family="CoreSansAR-65Bold, Core Sans AR" font-size="18" font-weight="bold" letter-spacing="-0.5">
                        <tspan x="56" y="64">empreinte.com</tspan>
                      </text>
                    </g>
                  </g>
                </svg>
              </div>
            <div id="light-fg-logo-mobile" class="isFM" v-if="componentStyle.mode=='demo' && !collapse && isFM">
                   <img src="../assets/img/logo/logoFrogBlack.png" class="image_base64 logo " alt="Logo"  />
              </div>
              <div id="dark-fg-logo-mobile" class="isFM" v-if="componentStyle.mode=='demo' && !collapse &&  isFM">
                   <img src="../assets/img/logo/logoFrogWhite.png" class="image_base64 logo " alt="Logo"  />
              </div>
          </span>
        </router-link>
        <div
          class="search-input-container"
          :class="[{ in: isSearchInputVisible }, componentStyle.searchInput]"
          v-if="isSearchInputVisible && !collapse"
        >
          <search-bar
            :in-submit="search"
            :placeholder="$t('buttons.search')"
            :title="$t('buttons.search')"
            @changed="keywordChanged"
            @blurred="searchInputBlurred"
          ></search-bar>
        </div>
        <button
          :class="['btn btn-link search-button-toggler',{'search-input-toggler':!isSearchInputVisible}, componentStyle.searchInput]"
          type="button"
          @click="toggleSearchInput()"
          v-if="!collapse "
        >
          <span class="icon search" v-if="!isSearchInputVisible"></span>
          <span class="icon toggle" v-if="isSearchInputVisible "></span>
        </button>
        <div class="switch-mode" v-if="componentStyle.switchMode && !isSearchInputVisible && !collapse">
          <switch-mode :id="'switchMode-mobile'"></switch-mode>
        </div>
        <div class="buttons-nav-container" v-if="!isSearchInputVisible" >
          <b-dropdown
            class="dropdown-lang"
            v-has-permission="'videos_multiple_languages'"
            v-if="showLang"
            v-model="selectedLang"
          >
            <div slot="button-content" class="dropdown-image">
              <img class="image_Lang" :src="selectedLang.image" />
              <span class="dropdown-text lang-current">{{ selectedLang.text }}</span>
            </div>
            <b-dropdown-item
              v-for="option in langs"
              :key="option.value"
              :value="option.value"
              @click="changeLang(option)"
            >
              <img :src="option.image" class="image_Lang" />
              <span class="dropdown-text">{{ option.text }}</span>
            </b-dropdown-item>
          </b-dropdown>
          <button
            ref="navbarToggler"
            class="navbar-toggler"
            type="button"
            data-toggle="collapse"
            data-target="#navbar"
            aria-controls="navbar"
            :aria-expanded="collapse ? 'true' : 'false'"
            aria-label="Toggle navigation"
            @click="collapse = !collapse"
          >
            <span class="navbar-toggler-icon" v-if="!collapse && componentStyle.mode=='default'"></span>
            <span class="icon-demo-menu" v-if="!collapse && componentStyle.mode=='demo'"></span>
            <span class="demo-menu" v-if="!collapse && componentStyle.mode=='demo'">
              <svg width="1.5em" height="1.5em" viewBox="0 0 38 28" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">

    <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <rect  x="0" y="0" width="38" height="28"></rect>
        <path class="fillmenu" d="M36,24 C37.1045695,24 38,24.8954305 38,26 C38,27.1045695 37.1045695,28 36,28 L2,28 C0.8954305,28 0,27.1045695 0,26 C0,24.8954305 0.8954305,24 2,24 L36,24 Z M36,12 C37.1045695,12 38,12.8954305 38,14 C38,15.1045695 37.1045695,16 36,16 L2,16 C0.8954305,16 0,15.1045695 0,14 C0,12.8954305 0.8954305,12 2,12 L36,12 Z M36,0 C37.1045695,0 38,0.8954305 38,2 C38,3.1045695 37.1045695,4 36,4 L2,4 C0.8954305,4 0,3.1045695 0,2 C0,0.8954305 0.8954305,0 2,0 L36,0 Z" fill="#FFFFFF"></path>
    </g>
</svg>

            </span>

            <span class="icon-demo-cancel_2" v-if="collapse"></span>
          </button>
        </div>

        <div class="collapse navbar-collapse" id="navbar" :class="'navbar-mobile-'+componentStyle.mode"  >
           <ul class="navbar-nav mr-auto" >
            <li v-if="componentStyle.mode=='default'" data-target="#navbar" class="nav-item">
              <a
                href="#"
                class="nav-link"
                :class="{ 'router-link-active': currentCategory === 'trends' }"
                @click.prevent="setCategory('trends')"
              >
                {{ $t('categories.trends') }}
              </a>
            </li>
            <li v-if="componentStyle.mode=='default'" data-target="#navbar" class="nav-item">
              <a
                href="#"
                class="nav-link"
                :class="{ 'router-link-active': currentCategory === 'popular' }"
                @click.prevent="setCategory('popular')"
              >
                {{ $t('categories.popular') }}
              </a>
            </li>
            <li v-if="componentStyle.mode=='default'" data-target="#navbar" class="nav-item border-bottom" @click="setCategory('all')">
              <a
                href="#"
                class="nav-link"
                :class="{ 'router-link-active': currentCategory === 'all' && !currentTheme }"
                @click.prevent="setCategory('all')"
              >
                {{ $t('categories.all') }}
              </a>
            </li>

            <li
              v-if="!NOT_LIST_THEME && componentStyle.mode=='default'"
              data-target="#navbar"
              class="nav-item"
              @click="toggleNavbar(navItem.id)"
              v-for="(navItem, index) of items"
              :class="{ active: navItem.id === +currentTheme }"
              v-show="navItem.title"
            >
              <router-link class="nav-link" :to="{ path: '/theme/' + navItem.id }">
                {{ navItem.title }}
              </router-link>



              <div class="submenu" v-if="navItem.children && navItem.children.length > 0  ">
                <ul>
                  <li
                    v-for="child in navItem.children"
                    :key="child.id"
                    @click.stop="toggleNavbar(child.id)"
                    class="nav-item"

                    :class="{ active: child.id === +currentTheme }"
                  >
                    <router-link class="nav-link" :to="{ path: '/theme/' + child.id } ">
                      {{ child.title }}
                    </router-link>
                  </li>
                </ul>
              </div>


            </li>

             <div class="custom-navbar-nav" v-for="(navItem, index) of items" v-if="navItem.id !== 0 && componentStyle.mode=='demo'" >
               <div class="cursor nav-item"   @click.stop="toggleNavbar(navItem.id); closetoggle=true;showSubMenu=false" >
                 <span  class="custom-mb-menu custom-font nav-link"   :class="{ active: navItem.id === +currentTheme }" v-if=" navItem.children && navItem.children.length < 1 && index !==0"> {{navItem.title}}  </span>
               </div>

               <div class="dropdown show custom-mb-menu custom-font cursor nav-item" :class="{active: navItem.id === +currentTheme}" right data-toggle="dropdown"  aria-haspopup="true" :aria-expanded="collapse ? 'true' : 'false'"
                    v-on:click="withouttoggleNavbar(navItem.id);showSub(navItem.id,index+1,closetoggle) ; oldid=navItem.id ;selectindex = +index"  v-if="navItem.children && navItem.children.length > 1"  >
                  <span class="nav-link custom-font"> {{navItem.title}}
                    <span class="fix-toggle">
                      <svg class="toggle-svg" :class="[{'activeIcon': +index === selectindex && showSubMenu && !closetoggle }]"  width="15px" height="11px" viewBox="0 0 19 11" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                         <g  stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
              <g transform="translate(-660.000000, -192.000000)" class="hoversvg" :class="[{'color-fill': +index === selectindex  && !closetoggle || navItem.id === +currentTheme }]" fill="#000000" fill-rule="nonzero">
                <g  transform="translate(0.000000, 105.000000)">
                  <g transform="translate(202.000000, 0.000000)">
                    <g  transform="translate(457.000000, 87.000000)">
                      <path d="M18.132,0.778 L10.373,8.539 L2.615,0.777 C2.24293482,0.419847143 1.65348351,0.42609371 1.28907072,0.791051213 C0.924657931,1.15600872 0.919291806,1.7454687 1.277,2.117 L9.7,10.546 L9.7,10.546 C9.87711431,10.7236415 10.1176495,10.8234839 10.3685,10.8234839 C10.6193505,10.8234839 10.8598857,10.7236415 11.037,10.546 L19.464,2.116 C19.7173766,1.88038432 19.821909,1.52523771 19.7365764,1.18992773 C19.6512437,0.854617749 19.3896609,0.592643362 19.054479,0.506809237 C18.719297,0.420975113 18.3639944,0.524976153 18.128,0.778 L18.132,0.778 Z" ></path>
                    </g>
                  </g>
                </g>
              </g>
            </g>
                      </svg>
                    </span>
                  </span>
                 <div class="dropdown-menu dropdownMenuLink">
                    <span class="dropdown-item" v-for="child in navItem.children"
                          :key="child.id"
                          @click.stop="toggleNavbar(child.id);closetoggle=true;showSubMenu=false"
                          :class="{ active: child.id === +currentTheme && navItem.id !== +currentTheme }"> {{child.title}}  </span>
                 </div>
               </div>
             </div>


           </ul >
          <div v-if="URL_LIVE && componentStyle.mode=='default'" class="mobileLiveButton btnLive d-flex" @click="redirectLive">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="#ff0000"
              width="24px"
              height="24px"
              viewBox="0 0 437.274 318.75"
              style="margin-right: 0.5em;"
            >
              <g id="noun_live_2146916" transform="translate(-2.5 -15.35)">
                <g id="btnLiveGroupe" data-name="Groupe 2" transform="translate(2.5 15.35)">
                  <path
                    class="big-arc"
                    d="M105.4,20.183c-6.444-6.444-16.57-6.444-22.554,0-6.444,6.444-6.444,16.57,0,22.554a186.286,186.286,0,0,1,54.314,132.1A183.759,183.759,0,0,1,82.383,306.483c-6.444,6.444-6.444,16.57,0,22.554a16.685,16.685,0,0,0,23.014,0,216.869,216.869,0,0,0,63.98-154.657C169.378,116.383,146.823,61.149,105.4,20.183Z"
                    transform="translate(267.897 -15.35)"
                    fill="#ffffff"
                  />
                  <path
                    class="big-arc"
                    d="M34.72,174.48c0-50.171,19.332-96.661,54.774-131.643,6.444-6.444,6.444-16.57,0-22.554-6.444-6.444-16.57-6.444-22.554,0C25.054,60.788,2.5,116.023,2.5,174.48A216.869,216.869,0,0,0,66.48,329.137a16.685,16.685,0,0,0,23.014,0c6.444-6.444,6.444-16.57,0-22.554A185.6,185.6,0,0,1,34.72,174.48Z"
                    transform="translate(-2.5 -14.99)"
                    fill="#ffffff"
                  />
                  <path
                    class="small-arc"
                    d="M93.237,31.983c-6.444-6.444-16.57-6.444-22.554,0-6.444,6.444-6.444,16.57,0,22.554a109.053,109.053,0,0,1,32.22,77.329,109.052,109.052,0,0,1-32.22,77.328c-6.444,6.444-6.444,16.57,0,22.554a16.685,16.685,0,0,0,23.014,0,140.318,140.318,0,0,0,41.426-99.883A143.53,143.53,0,0,0,93.237,31.983Z"
                    transform="translate(225.743 27.164)"
                    fill="#ffffff"
                  />
                  <path
                    class="small-arc"
                    d="M51.06,131.966A108.261,108.261,0,0,1,83.28,54.637c6.444-6.444,6.444-16.57,0-22.554-6.444-6.444-16.57-6.444-22.554,0a141.684,141.684,0,0,0,.46,200.686A16.112,16.112,0,0,0,84.2,210.215,109.078,109.078,0,0,1,51.06,131.966Z"
                    transform="translate(58.029 27.524)"
                    fill="#ffffff"
                  />
                  <path
                    d="M63.654,38.836A14.481,14.481,0,0,0,41.1,50.8V147a14.481,14.481,0,0,0,22.554,11.967l72.265-48.33a14.621,14.621,0,0,0,0-24.4Z"
                    transform="translate(136.571 60.356)"
                  />
                </g>
              </g>
            </svg>
            Live
          </div>
        </div>
      </nav>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import SearchBar from '~/node_modules/search-bar/src/components/Component.vue';
import ListItems from '~/node_modules/list-items/src/components/Component.vue';
import Mixin from '@/mixins/Mixin';
import SwitchMode from './CustomComponents/SwitchMode.vue';

import HasPermission from '../directives/HasPermission.js';

export default {
  name: 'HeaderMenu',
  components: {
    SearchBar,
    ListItems,
    SwitchMode
  },
  mixins: [Mixin],
  directives: {
    HasPermission,
  },
  data() {
    return {
      selectindex:'',

      collapse:false,
      showSubMenu:true,
      oldid:'',
      closetoggle:false,
      ShowBar:false,

      NOT_LIST_THEME : process.env.NOT_LIST_THEME ? process.env.NOT_LIST_THEME : false,
      isSearchInputVisible: false,
      title: '',
      selectedLang: {},
      URL_LIVE : process.env.URL_LIVE ? process.env.URL_LIVE : false,
      langs: [
        {
          value: 'fr',
          text: 'FR',
          image:
            'data:image/svg+xml;utf8;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pgo8IS0tIEdlbmVyYXRvcjogQWRvYmUgSWxsdXN0cmF0b3IgMTkuMC4wLCBTVkcgRXhwb3J0IFBsdWctSW4gLiBTVkcgVmVyc2lvbjogNi4wMCBCdWlsZCAwKSAgLS0+CjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgdmVyc2lvbj0iMS4xIiBpZD0iTGF5ZXJfMSIgeD0iMHB4IiB5PSIwcHgiIHZpZXdCb3g9IjAgMCA1MTIgNTEyIiBzdHlsZT0iZW5hYmxlLWJhY2tncm91bmQ6bmV3IDAgMCA1MTIgNTEyOyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSIgd2lkdGg9IjUxMnB4IiBoZWlnaHQ9IjUxMnB4Ij4KPHBhdGggc3R5bGU9ImZpbGw6IzQxNDc5QjsiIGQ9Ik0xNzAuNjY3LDQyMy43MjFIOC44MjhjLTQuODc1LDAtOC44MjgtMy45NTMtOC44MjgtOC44MjhWOTcuMWMwLTQuODc1LDMuOTUzLTguODI4LDguODI4LTguODI4ICBoMTYxLjgzOVY0MjMuNzIxeiIvPgo8cmVjdCB4PSIxNzAuNjciIHk9Ijg4LjI3NyIgc3R5bGU9ImZpbGw6I0Y1RjVGNTsiIHdpZHRoPSIxNzAuNjciIGhlaWdodD0iMzM1LjQ1Ii8+CjxwYXRoIHN0eWxlPSJmaWxsOiNGRjRCNTU7IiBkPSJNNTAzLjE3Miw0MjMuNzIxSDM0MS4zMzNWODguMjczaDE2MS44MzljNC44NzUsMCw4LjgyOCwzLjk1Myw4LjgyOCw4LjgyOHYzMTcuNzkzICBDNTEyLDQxOS43Nyw1MDguMDQ3LDQyMy43MjEsNTAzLjE3Miw0MjMuNzIxeiIvPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8L3N2Zz4K',
        },
        {
          value: 'en',
          text: 'EN',
          image:
            'data:image/svg+xml;utf8;base64,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',
        },
      ],
      showLang: false,
    };
  },
  watch: {
    keyword(newVal) {
      this.title = newVal;
    },
  },
  computed: {
    ...mapGetters({
      items: 'themes/getAllThemes',
      currentTheme: 'videos/getCurrentTheme',
      currentCategory: 'videos/getCurrentCategory',
      keyword: 'videos/getKeyword',
      live: 'live/getLive',
      isFullWidth: 'layout/isFullWidth',
      isSideNav: 'layout/isSideNav',
      currentLogo: 'layout/getCurrentLogo',
      componentStyle: 'layout/getComponentStyle',
      IsSiteEmbed:'layout/getIsSiteEmbed',
      typeLogo:'layout/getTypeLogo'
    }),
      isFM(){
        return process.env.isFM
      },
    getLogo() {
      return this.currentLogo ? this.currentLogo : './static/logo.png?v=1';
    },
    showLogo(){
      if (!this.IsSiteEmbed && this.isFullWidth)
        return true;
      else
        return false;
    },
  },
  props: {
    query: {
      type: String,
      default: '',
    },
  },
  methods: {
    ...mapActions('videos', ['setKeyword', 'setCurrentCategory']),
    ...mapActions('themes', ['fetchThemes']),
    ...mapActions('live', ['fetchLive']),
    showSub(id,index){
      this.closetoggle = false;
      if(this.oldid != id ) {
        this.showSubMenu=true
        return
      }
      if(id===index){
        this.showSubMenu = ! this.showSubMenu
      }
    },


    search(keyword) {
      this.setKeyword(keyword);
      this.$router.push({ name: 'home', params: { category: 'all' } });
      if (keyword !== '') {
        this.$router.push({ query: { q: keyword } });
      }
    },
    redirectLive() {

      console.log("this.live",Object.assign(this.live))
     /* let loc = this.live && this.live.permalien_live
        ? this.live.permalien_live
        : process.env.URL_LIVE
      if (!loc)
      location.replace('404');
      else
        location.replace(loc);*/
    },
    keywordChanged(keyword) {
      // this.setKeyword(keyword);
    },
    searchInputBlurred(keyword) {
      this.isSearchInputVisible = !!keyword;
    },
    toggleSearchInput() {
      this.isSearchInputVisible = !this.isSearchInputVisible;
    },
    getSearchWord() {
      const query = this.$route.query.q;
      if (query) {
        this.setKeyword(query);
        this.title = query;
      }
    },

    toggleNavbar(id, category) {
      if(id!== this.$route.params.themeId)
        this.itemClicked(id, category);
      this.$refs.navbarToggler.click();
    },
    withouttoggleNavbar(id, category) {
      if(id !== this.$route.params.themeId)
        this.itemClicked(id, category);
    },
    changeLang(lang) {
      this.selectedLang = lang;
      this.$root.$i18n.locale = this.selectedLang.value;
      localStorage.setItem('lang-fo', this.selectedLang.value);
    },
    setCategory(category) {
      this.setCurrentCategory(category);
      this.toggleNavbar(0, category);
    },
    updateCurrentLanguage() {
      const userLang = localStorage.getItem('lang-fo');
      this.selectedLang = this.langs.find(l => l.value === userLang);
    },
  },
  created() {
    this.fetchThemes(this.componentStyle.mode);
    if(this.URL_LIVE){
      setTimeout(() => {
        this.fetchLive({ duration: '500' });
      }, 200);
    }

    this.updateCurrentLanguage();
  },
  mounted() {
    this.getSearchWord();
    if(this.URL_LIVE){
      let duration = { duration: '500' };
      setInterval(() => {
        this.fetchLive(duration);
      }, 5000);
    }

  },
};
</script>

<!--SHOULD BE NOT SCOPED-->
<style lang="scss">
@import '../assets/scss/_variables.scss';
@import '../assets/scss/_logo.scss';

%search-input-shared {
  .search-input-container {
    flex: 1 0 0;
    &.full-width {
      padding: 1rem 16px 0 4rem;
    }
    &.side-nav {
      padding: 1rem 7rem 0 0;
      position: relative;
      .btnLive {
        position: absolute;
        right: 0;
        top: 0;
        margin: 1rem 0 0;
        font-weight: 500;
        color: var(--primary-color);
        svg path {
          fill: var(--primary-color);
        }
      }
    }
    .search-bar-container {
      --search-bar-input-width: 99%;
      --search-bar-input-height: 2.5em;
      --search-bar-input-border: none;
      --search-bar-input-radius: none;
      --search-bar-input-bg: transparent;
      --search-bar-btn-border: none;
      --search-bar-btn-bg: transparent;
      --search-bar-input-border-top: none;
      --search-bar-input-border-right: none;
      --search-bar-input-border-left: none;
      --search-bar-btn-radius: 0;
      --search-bar-btn-border-top: none;
      --search-bar-btn-border-right: none;
      --search-bar-btn-border-left: none;
      --search-bar-btn-float: left;
      --search-bar-input-text-size: 1rem;
      --search-bar-placeholder-color: #555555;
      --search-bar-input-text-color: #333;
      --search-bar-input-text-padding: 0 0 0 0.5em;
    }

    .search-bar {
      --search-bar-input-text-width: 95%;
      --search-bar-input-placeholder-color: #8e8e8e;
    }

    .icon {
      --search-bar-icon-width: 1em;
      --search-bar-icon-height: 1.5em;
      --search-bar-icon-color: #8e8e8e;
    }
  }
}

.header-container.header-menu {
  position: sticky;
  top: 0;
  z-index: 1002; // Player control-bar
  background: #ffffff;
  margin: 0 -15px;
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.05), inset 0 -1px 0 rgba(0, 0, 0, 0.1);
  &.header-collapse {
    position: fixed;
    width: 100%;
  }
  &.side-nav {
    padding: 0 15px;
  }
  .desktop-header {
    @extend %search-input-shared;
    .navbar-brand {
      padding: 0;
        &.isFM{
            width: 240px;
            height: 80px;
        }
    }
    .list-items {
      --list-items-bg-color: var(--primary-color);
      .list-ul {
        display: flex;
        align-items: center;
        justify-content: start;
        --list-items-list-ul-bg-color: var(--primary-color);
        --list-ul-padding: 0.5em 15px;
        .list-li {
          position: relative;
          --list-number-items: 3.5;
          height: auto;
          &:first-child {
            width: 2em;
            .item-name {
              display: none;
            }
            .activeBtn {
              background-color: var(--primary-color) ;
            }
            .item:hover {
              background-color: var(--primary-color);
            }
          }
          &:not(:first-child) {
            /*flex: 1 0 0;*/
            &:after {
              content: '';
              position: absolute;
              left: 0;
              top: calc(50% - 0.5em);
              height: 1em;
              border-right: 1px solid rgba(255, 255, 255, 0.4);
            }
            .item-icon-container {
              display: none;
            }
          }
          .item {
            --list-items-item-width: 100%;
            --list-items-item-padding: 0.2em 0;
            --list-items-item-name-color: #ffffff;
            --list-items-item-margin: 0;
            --list-items-item-over-textcolor: #ffffff;
            --list-items-item-over: rgba(255, 255, 255, 0.5);
            --list-items-item-border-radius: 0;
            --list-items-item-font-size: 0.9rem;
            &.activeBtn {
              background-color: #ffffff;
              --list-items-item-name-color: #19589e !important;
              .item-name {
                color: var(--primary-color);
              }
            }
            .item-icon-container {
              padding: 0.5em;
              --list-items-item-icon-container-margin: -0.5em 0 0 0.12em;
              --list-items-item-icon-container-height: 2.2em;
              svg {
                width: 1.2em;
                height: 1.2em;
              }
            }
            .item-name {
              font-weight: 700;
              --list-items-item-name-margin: 0.1em auto;
              --list-items-item-name-width: auto;
              --list-items-item-name-padding: 0 0.2em;
            }
          }
        }
      }
    }
  }
  .mobile-header {
    padding: 0 14px;
    .logo-container {
      img {
        /*todo logo*/
        /*width: 35px;*/
        height: auto;
        margin-right: 1em;
      }
        .isFM{
            &#light-fg-logo-mobile, &#dark-fg-logo-mobile{
                margin-left: 1em;
            }
        }
    }
    .navbar-toggler {
      border: none;
    }
    @extend %search-input-shared;
    .search-input-container {
      background-color: white;
      right: 4em;
      top: 0.5em;
      width: 0;
      padding: 0;
      overflow: hidden;
      transition: all 0.3s ease;
      &.in {
        padding: 0 0 0 2em;
        width: calc(100vw - 4em);
      }
      .icon {
        display: none;
      }
    }
    .search-button-toggler {
      right: 4em;
      top: 1em;
      .icon {
        display: block;
        width: 1em;
        height: 1em;
        background-size: contain;
        background: no-repeat center;
        &.search {
          background-image: url(data:image/svg+xml;utf8;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pgo8IS0tIEdlbmVyYXRvcjogQWRvYmUgSWxsdXN0cmF0b3IgMTYuMC4wLCBTVkcgRXhwb3J0IFBsdWctSW4gLiBTVkcgVmVyc2lvbjogNi4wMCBCdWlsZCAwKSAgLS0+CjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+CjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgdmVyc2lvbj0iMS4xIiBpZD0iQ2FwYV8xIiB4PSIwcHgiIHk9IjBweCIgd2lkdGg9IjE2cHgiIGhlaWdodD0iMTZweCIgdmlld0JveD0iMCAwIDMwLjIzOSAzMC4yMzkiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDMwLjIzOSAzMC4yMzk7IiB4bWw6c3BhY2U9InByZXNlcnZlIj4KPGc+Cgk8cGF0aCBkPSJNMjAuMTk0LDMuNDZjLTQuNjEzLTQuNjEzLTEyLjEyMS00LjYxMy0xNi43MzQsMGMtNC42MTIsNC42MTQtNC42MTIsMTIuMTIxLDAsMTYuNzM1ICAgYzQuMTA4LDQuMTA3LDEwLjUwNiw0LjU0NywxNS4xMTYsMS4zNGMwLjA5NywwLjQ1OSwwLjMxOSwwLjg5NywwLjY3NiwxLjI1NGw2LjcxOCw2LjcxOGMwLjk3OSwwLjk3NywyLjU2MSwwLjk3NywzLjUzNSwwICAgYzAuOTc4LTAuOTc4LDAuOTc4LTIuNTYsMC0zLjUzNWwtNi43MTgtNi43MmMtMC4zNTUtMC4zNTQtMC43OTQtMC41NzctMS4yNTMtMC42NzRDMjQuNzQzLDEzLjk2NywyNC4zMDMsNy41NywyMC4xOTQsMy40NnogICAgTTE4LjA3MywxOC4wNzRjLTMuNDQ0LDMuNDQ0LTkuMDQ5LDMuNDQ0LTEyLjQ5MiwwYy0zLjQ0Mi0zLjQ0NC0zLjQ0Mi05LjA0OCwwLTEyLjQ5MmMzLjQ0My0zLjQ0Myw5LjA0OC0zLjQ0MywxMi40OTIsMCAgIEMyMS41MTcsOS4wMjYsMjEuNTE3LDE0LjYzLDE4LjA3MywxOC4wNzR6IiBmaWxsPSIjOGU4ZThlIi8+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPC9zdmc+Cg==);
        }
        &.toggle {
          background-image: url(data:image/svg+xml;utf8;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pgo8IS0tIEdlbmVyYXRvcjogQWRvYmUgSWxsdXN0cmF0b3IgMTguMS4xLCBTVkcgRXhwb3J0IFBsdWctSW4gLiBTVkcgVmVyc2lvbjogNi4wMCBCdWlsZCAwKSAgLS0+CjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgdmVyc2lvbj0iMS4xIiBpZD0iQ2FwYV8xIiB4PSIwcHgiIHk9IjBweCIgdmlld0JveD0iMCAwIDIxMi45ODIgMjEyLjk4MiIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgMjEyLjk4MiAyMTIuOTgyOyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSIgd2lkdGg9IjE2cHgiIGhlaWdodD0iMTZweCI+CjxnIGlkPSJDbG9zZSI+Cgk8cGF0aCBzdHlsZT0iZmlsbC1ydWxlOmV2ZW5vZGQ7Y2xpcC1ydWxlOmV2ZW5vZGQ7IiBkPSJNMTMxLjgwNCwxMDYuNDkxbDc1LjkzNi03NS45MzZjNi45OS02Ljk5LDYuOTktMTguMzIzLDAtMjUuMzEyICAgYy02Ljk5LTYuOTktMTguMzIyLTYuOTktMjUuMzEyLDBsLTc1LjkzNyw3NS45MzdMMzAuNTU0LDUuMjQyYy02Ljk5LTYuOTktMTguMzIyLTYuOTktMjUuMzEyLDBjLTYuOTg5LDYuOTktNi45ODksMTguMzIzLDAsMjUuMzEyICAgbDc1LjkzNyw3NS45MzZMNS4yNDIsMTgyLjQyN2MtNi45ODksNi45OS02Ljk4OSwxOC4zMjMsMCwyNS4zMTJjNi45OSw2Ljk5LDE4LjMyMiw2Ljk5LDI1LjMxMiwwbDc1LjkzNy03NS45MzdsNzUuOTM3LDc1LjkzNyAgIGM2Ljk4OSw2Ljk5LDE4LjMyMiw2Ljk5LDI1LjMxMiwwYzYuOTktNi45OSw2Ljk5LTE4LjMyMiwwLTI1LjMxMkwxMzEuODA0LDEwNi40OTF6IiBmaWxsPSIjOGU4ZThlIi8+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPC9zdmc+Cg==);
        }
      }
    }
    .dropdown-lang {
      margin-top: 5px;
    }
  }
}
.darkMode{
        .logo-container {
            .isFM{
                 &#dark-fg-logo-mobile,&#dark-fg-logo {
                  --primary-color: #6ba52f!important;
                }
            }
        }
}
nav.navbar {
  padding: 0.5rem 15px;
    &.isFM{
        @media screen and (max-width: 1200px) and (min-width: 992px){
            margin: 0em 15px 0;
        }
    }
}
.navbarList {
  display: flex;
  width: 100%;
  padding-right: 25px;
  padding-left: 15px;
  margin-right: auto;
  margin-left: auto;
  min-height: 45px;
}
.list-items {
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
  margin-right: auto;
  margin-left: auto;
}

.nav-link {
  &.router-link-active {
    color: var(--primary-color) !important;
  }
}

@media (max-width: 575px) {
  .container {
    padding-right: 0;
    padding-left: 0;
  }
}

@media (min-width: 992px) {
  .navbarList {
    max-width: 960px;
  }
}

@media (min-width: 1200px) {
  .container,
  .navbarList {
    max-width: 1180px !important;
  }
}

@media (min-width: 1600px) {
  .container,
  .navbarList {
    max-width: 1400px !important;
  }
}

.navbar-container {
  background-color: var(--primary-color);
  display: flex;
  justify-content: center;
}

/*
   * IE 11 Support
   */
.search-button-toggler.btn:focus{
  box-shadow: none!important;
}
.search-bar-container {
  width: 100%;
  height: inherit;
  border-top: 2.5em;
  border-right: none;
  border-bottom: 1px solid #c4c5c6;
  border-left: none;
  border-radius: 0;
  background: transparent;
  opacity: 1;
  padding: 10px;
  outline: none;
}

.search-bar {
  width: 95%;
  color: #333;
  padding: 0 0 0 0.5em;
  font-size: 1rem;
}

.header-container.header-menu .icon {
  width: 1em;
  height: 1.5em;
  color: #8e8e8e;
  float: left;
}

.list-items {
  background-color: var(--primary-color);
  font-family: var(--list-items-font-family, sans-serif);
}

.list-ul {
  list-style-type: none;
  overflow: visible !important;
  margin: 0;
  padding: 0.5em 15px;
  background-color: var(--primary-color);
  width: 100%;
  vertical-align: middle;
}

.list-li {
  height: 100%;
  display: inline-block;
}
.btnLive {
  display: flex;
  align-items: center !important;
  border-radius: unset !important;
  color: #fff;

  svg path {
    fill: #fff;
  }
  #btnLiveGroupe {
    .big-arc {
      animation: hideShow 2s 1.5s ease infinite;
    }
    .small-arc {
      animation: hideShow 2s 1s ease infinite;
    }
  }
  &:disabled,
  &[disabled] {
    background: #407156 !important;
    border-color: #407156 !important;
    color: #22503d !important;
    opacity: 1;

    svg path {
      fill: #22503d;
    }
    #btnLiveGroupe {
      .big-arc {
        animation: none;
      }

      .small-arc {
        animation: none;
      }
    }
  }
}

.item {
  float: left;
  text-align: center;
  padding: 0.2em 0;
  font-size: 0.9rem;
  height: 100%;
  margin: 0;
  border-radius: 0;
  width: 100%;
  color: #ffffff;
  &.activeBtn {
    background-color: #ffffff;
    color: var(--primary-color) !important;
    .item-name {
      color: var(--primary-color);
    }
  }
}

.item-icon-container {
  float: left;
  width: 30%;
  height: 2.2em;
  padding: 0;
  margin: -0.5em 0 0 0.12em;
}

.item-icon {
  width: 100%;
  height: 100%;
  padding: 0;
  margin: 0;
}

.item-name {
  float: left;
  width: auto;
  margin: 0.1em auto;
  padding: 0 0.2em;
}

.item:hover {
  background-color: rgba(255, 255, 255, 0.5);
  cursor: pointer;
  color: #fff;
  fill: #fff;
}
.activeBtn {
  background-color: #e3e3e3;
  fill: #fff;
}
.mobileLiveButton {
  cursor: pointer;
  color: var(--primary-color);
  svg path {
    fill: var(--primary-color);
  }
}

@media all and (-ms-high-contrast: none) {
  .color-container {
    display: none !important;
  }
}

@keyframes hideShow {
  0% {
    opacity: 0;
  }
  50% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}

.dropdown-lang {
  transform: translateY(10px);
  .dropdown-toggle,
  .dropdown-toggle:hover,
  .dropdown-toggle.show,
  .dropdown-toggle.active,
  .dropdown-toggle:active {
    background: none !important;
    color: #000 !important;
    border: none !important;
    display: flex;
    flex-direction: row;
    box-shadow: none !important;
  }
  .image_Lang {
    width: 20px;
  }
  .dropdown-image {
    margin-top: -10px;
  }

  .dropdown-text {
    font-family: sans-serif;
    font-size: 14px;
    font-weight: bold;
    color: #41479b;

    &.lang-current {
      margin-right: 7px;
    }
  }

  .dropdown-menu {
    min-width: 1rem;
  }
}
.image_base64 {
  width: $width;
}
@media (max-width: 991px) {
  nav.navbar {
    padding: 0.5rem 0;
  }
}
  .logo {
    width: $width;
  }
@media (max-width: 520px) {
  .logo-part1 {
    font-size: 15px;
    font-weight: 700;
    line-height: 40px;
    color: var(--secondary-color) !important;
  }
  .logo-part2 {
    font-size: 15px;
    font-weight: 200;
    line-height: 40px;
    color: var(--secondary-color) !important;

  }
}

/* if search-bar-container  rectangle*/
.search-input-container.rectangle{
  justify-content: flex-end;
  display: flex;
  align-items: baseline;
}

.header-container.header-menu .desktop-header .search-input-container.rectangle .search-bar-container {
  border: solid 1px #b8b8b8;
  border-radius: 3px;
  background-color: #f1f1f1;
  color: #a1a1a1;
  padding: 0.5em!important;
  width: 350px!important;
}
.header-container.header-menu .mobile-header .search-input-container.rectangle .search-bar-container {
  border: solid 1px #b8b8b8;
  border-radius: 3px;
  background-color: #f1f1f1;
  color: #a1a1a1;
  padding: 0.5em!important;
  width: 100%!important;
}

.search-input-container.rectangle{
  padding: 0!important;
}

/* if header  mode-demo */
.mode-demo.header-container.header-menu{

  .item-icon-container{
    padding: 0.5em .4em!important;
  }

.custom-mb-menu .nav-link .active{
  background-color:#e8e8e8 ;
}

  .item-name , .nav li .submenu ul li a , .btndemoLive , .pumpkin ,.title-demo {
    font-family: Roboto
  }

   .item.activeBtn .item-name , .item.activeBtn{
    color: #ffffff!important;
   }

  .switch-mode {
    margin-left: 25px;
  }
  .btndemoLive{
    justify-content: space-around;
    width: 120px;
    height: 42px;
    border-radius: 3px;
  display: flex;
  align-items: center;
  color: #262626;
  background-color: #cacaca;
  border-color:#cacaca;
    padding: 0.1em 0.5em;
    text-transform: uppercase;
    /* font-size: 21px; */
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
  }
  .btn-secondary:not(:disabled):not(.disabled):active{
    color: #262626;
    background-color: #cacaca;
    border-color:#cacaca;
  }

}

.mode-demo .desktop-header , .mode-demo.header-container.header-menu {
  background-color: var(--primary-color)!important;
}



.darkMode{
  .mode-demo{
    .nav li .submenu ul{
      background-color: #383838!important;
    }
    .nav li .submenu ul li{
      border-bottom: none!important;

    }
    .nav li .submenu ul li:not(:last-child){
      border-bottom: none!important;
    }
    .nav li .submenu ul li a {
      color: #a1a1a1!important;
    }
  }
  .nav li:hover .submenu {
    background-color: #383838!important;
  }
}


.demo{
  .card-wrapper .card .tag-info {
    font-size: 1.2em;
  }
}

/* if navbar   demo*/
.mode-demo{


  .navbar-mobile-demo .navbar-nav{
    padding-top: 1em;
  }
  .submenu{
    padding: .5em!important;
  }
 .list-ul {
   padding: 0.5em 0 !important;
 }
  .navbar-container.demo .list-li:first-child {
    width: 35px!important;
    margin-right: 1em;
  }

  .nav li .submenu ul{
    background-color: white!important;

  }
  .nav li:hover .submenu {
    display: block;
    background-color: white;
    z-index: 99;
  }
  .nav li .submenu ul li:hover {
    background-color: var(--secondary-color) !important;
    color: white!important;
    a {
      color: white!important;
    }
  }
  .nav li .submenu ul li a {
    color: #212529!important;
  }
  .nav li .submenu ul li a:hover {
    color: white!important;
  }
}

.navbar-container.demo {
  z-index: 0!important;
  //use param
  .list-items .list-ul .list-li .item{
    --list-items-item-name-color: #262626!important;
    --list-items-item-over: var(--secondary-color) !important;
    --list-items-item-border-radius:5px!important;
  }
  .item.activeBtn , .list-li:first-child .activeBtn , .header-container.header-menu .desktop-header .list-items .list-ul .list-li:first-child .activeBtn
  {

    background-color: var(--secondary-color) !important;
  }
  .list-li:after{
    content: none!important;
  }
  .list-li{
    width: auto!important;
    &:not(:first-child) {
      margin-right:1em ;
    }
  }
  .list-li:first-child {
    width: 3em!important;
  }

  .list-items {
    --list-items-bg-color: var(--primary-color);
    &.nav{
        padding: 0 15px !important;
    }
    .list-ul {
      display: flex;
      align-items: center;
      justify-content: start;
      --list-items-list-ul-bg-color: var(--primary-color);
      --list-ul-padding: 0.5em 15px;

      .list-li {
        position: relative;
        --list-number-items: 3.5;

        &:first-child {
          width: 2em;

          .item-name {
            display: none;
          }

          .activeBtn {
            background-color: var(--secondary-color);
          }

          .item:hover {
            background-color: var(--secondary-color);
          }
        }
      }
    }
  }

}

.demo-menu{
  svg path {
    fill: #484848;
  }
}



/*-----------------darkMode-------------------------------*/

$darkColorV0 : #131313;
$darkColorV1 : #2a2a2a;
$darkColorV2 : #383838;
$darkColorV3 : #313131;

$light:#a1a1a1;


.darkMode{
  .demo-menu{
    svg path {
      fill: #a1a1a1;
    }
  }

        --primary-color:#2a2a2a!important;
        --color-title:#cacaca!important;

.icon-demo-home2_outline{
  color: #a1a1a1;
}
  .item.activeBtn .item-name , .item.activeBtn .icon-demo-home2_outline{
    color: #ffffff!important;
  }


  .list-items {
    .list-ul {
      .list-li {
          .item:hover {
            .item-name{
            color: white!important;
          }}
        }
      }
    }


.icon-demo-live{
  color:#a1a1a1
}

  .desktop-header,.header-container.header-menu{
    background-color: $darkColorV1;
  }
  .navbar-container{
    background-color: $darkColorV1;
  }
  .custom-Btn-Live{
    background-color:$darkColorV0 ;
    color:$light
  }
  .list-ul {
    --list-items-list-ul-bg-color:#2a2a2a!important;
  }
  .title-menu{
    color: $light!important;
  }
  .main-page-container{
    background-color:$darkColorV2!important;
  }
  .search-bar-container{
    border: solid 1px $darkColorV0!important;
    background-color: $darkColorV2!important;
  }

  /deep/ #video-wrapper .video-wrapper , .video-list .card{
    background-color:$darkColorV3!important;
  }

  .header-container.header-menu .desktop-header .list-items .list-ul .list-li .item .item-name{
    color: #a1a1a1;
  }
  .header-container.header-menu .desktop-header .list-items .list-ul .list-li .item.activeBtn .item-name{
    color:white!important;
  }

  .header-container.header-menu .mobile-header .search-input-container{
    background-color: $darkColorV1;
  }

  .btndemoLive{
     background-color: #131313!important;
     border-color: #131313!important;
     color: #a1a1a1!important;
  }



}

/****************************/
.have-switch{
  .mobile-header{
    .switch-mode {
      margin-left: 0px!important;
      margin-top: 0.5em;
    }
  }
  .search-input-toggler {
    display: flex;
    justify-content: flex-end;
    width: calc(100% - 225px)!important;
  }

}




.header-container.header-menu .mobile-header .search-input-toggler {
  display: flex;
  justify-content: flex-end;
  width: calc(100% - 175px);
}

  .demo-icons-live{
    color: #262626;
    margin-right: 0.2em;
    font-size: 0.9em;
  }


/* mode default*/
.default {
  .header-container.header-menu .mobile-header .search-input-toggler {
    width: calc(100% - 190px);
  }

  .header-container.header-menu .desktop-header .list-items .list-ul .list-li:first-child .activeBtn {
  background-color: var(--primary-color)!important;
  }
  .header-container.header-menu .mobile-header .search-input-container.in{
    padding: 0!important;
  }
  .search-input-toggler {
    right:50px!important;
  }
  .header-container.header-menu .mobile-header .search-input-container.rounded .search-bar-container{
    width: 100%!important;
  }
  .info-wrapper{
    height: 100% !important;
  }
}




.darkMode{
  .card-text , .card-duration {
    color: #cacaca !important ;
  }
  .navbar-mobile-demo{

  background-color: #e8e8e8;
  }
  .nav-link {
    color: white!important;
  }

  .nav-item:hover{
    background-color: #f0f0f0;
    color: var(--secondary-color) !important;
    .nav-link{
      color: var(--secondary-color)!important;
    }
  }
}





@media screen  and (max-width: 477px){
  .icon-demo-calendar,.icon-demo-view{
    font-size: 1em!important;
  }
.pumpkin{
  font-size: 14px!important;
}
}

.navbar-mobile-demo{



  @media screen and(min-width: 480px) and (max-width: 992px){
     .dropdown .nav-item , .nav-item{
       margin-right: 4em!important;
     }
    .dropdown.custom-mb-menu{
    margin-right: 4.5em!important;}

  }


  .dropdown.custom-mb-menu{
    margin: 0 2.3em;
  }

  .nav-link.active{
    background-color: #e8e8e8;
  }

  background-color: white;
  margin: 0 -15px ;

  .navbar-nav{
    width: 80%;
    margin-left: 22%;
    background-color: white;
    height: 100%;
  }

  .nav-item{
    margin: 0 2em;
    padding-left: 0!important;
  }
  .nav-link {
    color: #262626;
    padding: 0.5em 1em;
    border-bottom: 1px solid #e8e8e8;
    font-size: 18px;
  }
  .nav-item:hover{
    background-color: #e8e8e8;
    color: var(--secondary-color);
    .nav-link{
      color: var(--secondary-color);
    }
  }
  .nav-item.active{
    background-color: #e8e8e8;
    color: var(--secondary-color);}
.router-link-active{
  color: var(--secondary-color) !important;

}



}

.navbar{
  min-height: 75px!important;
}
@media screen and (min-width: 993px) {

  .mode-demo.header-container.header-menu {
    position: initial !important;
  }
}

.empty-container{
    &.isFM{
        width: 500px;
        height: 80px;
    }
}
.mode-demo{

.item-name{
  text-transform: uppercase;
  font-size: 21px;
  font-weight: 500!important;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #262626;
}

  .navbar .navbar-expand-lg{
    align-items: center;
    display: flex;
  }
  .search-input-container{
    margin-bottom: 0!important;
  }

  #navbar{
    height: 100%;
    z-index: 999;
    position: fixed!important;
  }
  .custom-mb-menu:hover {
    color: var(--secondary-color)!important;
  }
  .active{
    color: var(--secondary-color)!important;
  }
  .activeIcon{
    transform: rotate(180deg) !important;
  }
  .notActiveIcon{
    transform: rotate(0deg);
  }
  .color-fill{
    fill: var(--secondary-color ) !important;
  }
  div[aria-expanded=true]{
    color:var(--secondary-color ) !important;
  }

  .fix-toggle{
    position: absolute;
    left: 90%;
  }
  .dropdownMenuLink{
    position: relative!important;
    transform: none!important;
  }
  .custom-font{
    font-size: 14px;
    font-weight: 500!important;
  }
  .cursor{
    cursor: pointer;
  }
  .custom-navbar-nav:hover{
    color: var(--secondary-color)!important;
    .hoversvg{
      fill: var(--secondary-color ) !important;
    }
  }
  .header-container.header-menu .desktop-header .sub .list-ul .list-li:not(:last-child):after {
    opacity: 0.3!important;
  }
  .separator{
    border-bottom: solid 1px;
    color: white;
    top: 46px;
    position: relative;
    z-index: 6;}


  @media screen and (min-width: 992px){
    .navbar-collapse.collapse.show{
      display: none!important;
    }

  }


  @media (max-width: 992px) {
    .header-container.header-menu{
      position: sticky;
    }
    .navbar-container-sous-menu{
      display: none;
    }
    .navbar-collapse {
      position: absolute;
      top: 75px;
      right: 100%;
      padding-left: 15px;
      padding-right: 15px;
      padding-bottom: 15px;
      width: 108%;
      transition: all 0.3s ease;
      display: none;
      background-color:#22212180;
    }

    .navbar-collapse.show{
      display: block!important;

    }

    .navbar-collapse.collapsing {
      height: 100%!important;
      margin-left: 50%;
      transition: all 0.3s ease;
      width: 80%;
      position: absolute;
      display: none;
    }
    .navbar-collapse.show {
      left: -15px;
    }
    .custom-navbar-collapse{
      background-color: #eeeff0;
      width: 80%;
      position: absolute;
      right: 0px;
      height: 100%;
    }
  }

   .menu-label{
     font-size: 24px;
     color: #a1a1a1;
   }

  .title-menu{
    cursor: pointer;
    font-size: 17px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    color: #000000;
    margin-right: 2em;
    margin-top: 0.5em;
  }
  .title-menu:hover{
    color: var(--secondary-color ) !important;
  }
  .title-menu-active{
    color: var(--secondary-color ) !important;
  }
  .dropdown-menu{
    background-color: white;
    border: 0px !important;
    padding-left:5% ;
  }

  .dropdownMenuLink {
    .dropdown-item:hover, .dropdown-item:focus {
      background-color:  white !important;
      color:var(--secondary-color ) !important; ;
    }
  }
  .dropdown-item:hover, .dropdown-item:focus {
    background-color:  var(--primary-color ) !important;
    color:var(--secondary-color ) !important; ;
  }
  .dropdown-item{
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
  }
  .nav-item{
    padding-left: 2em;
  }
  .nav-link{
    color: #000000 !important;
    font-size: 18px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
  }
  .nav-link:hover{
    color:var(--secondary-color ) !important; ;
  }
  .nav-item.active .nav-link , .nav-link.active {
    color:var(--secondary-color ) !important; ;

  }



}
#dark-fg-logo-mobile, #light-fg-logo-mobile{
    width: 50px;
    height: 50px;
}





</style>



// WEBPACK FOOTER //
// src/components/HeaderMenu.vue